import React, { useState, useEffect, useContext } from "react";
import { FaThumbsUp } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import axios from "axios";
import config from "../Config";
import { useAtom } from 'jotai';
import DarkModeContext from '../Components/DarkModeContext';
import { isAuthAtom } from '../Services/store/atoms';

const FavoriteButton = ({ idModel }) => {
    const [isFavorite, setFavorite] = useState(false);
    const [count, setCount] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isAuth] = useAtom(isAuthAtom);
    const history = useHistory();
    const { darkMode } = useContext(DarkModeContext);

    const fetchFavoriteData = async () => {
        try {
            if (isAuth) {
                const response = await axios.get(
                    `${config.REACT_APP_BASE_URL}/api/v1/home/getFavorite/${idModel}`
                );
                setFavorite(response.data.isFavorite);
                setCount(response.data.favoriteCount);
            } else {
                const response = await axios.get(
                    `${config.REACT_APP_BASE_URL}/api/v1/home/getFavoriteCount/${idModel}`
                );
                setCount(response.data.favoriteCount);
                setFavorite(false);
            }
        } catch (error) {
            console.error("Error al cargar los datos del modelo:", error);
            setCount(0);
        }
    };

    useEffect(() => {
        fetchFavoriteData();
    }, [idModel, isAuth]);

    const handleFavoriteClick = async () => {
        if (!isAuth) {
            setShowLoginModal(true);
            return;
        }

        try {
            setIsAnimating(true);
            const response = await axios.post(
                `${config.REACT_APP_BASE_URL}/api/v1/home/storeFavorites/${idModel}`
            );
            setFavorite(response.data.isFavorite);
            setCount(response.data.favoriteCount);
        } catch (error) {
            console.error("Error al actualizar el estado de favoritos:", error);
        } finally {
            setTimeout(() => setIsAnimating(false), 500);
        }
    };

    const handleLoginClick = () => {
        history.push('/login');
    };

    return (
        <>
            <style>{`
                @keyframes subtleNeonPulse {
                    0%, 100% {
                        box-shadow: 0 0 2px rgba(244, 63, 94, 0.2), 0 0 6px rgba(244, 63, 94, 0.3), 0 0 10px rgba(244, 63, 94, 0.4);
                    }
                    50% {
                        box-shadow: 0 0 1px rgba(244, 63, 94, 0.1), 0 0 4px rgba(244, 63, 94, 0.2), 0 0 8px rgba(244, 63, 94, 0.3);
                    }
                }

                @keyframes heartbeat {
                    0% { transform: scale(1); }
                    30% { transform: scale(1.1); }
                    50% { transform: scale(1); }
                }

                .neon-glow {
                    animation: subtleNeonPulse 3s infinite ease-in-out;
                    border-color: rgba(244, 63, 94, 0.8);
                }

                .heartbeat {
                    animation: heartbeat 0.4s ease-in-out;
                }
            `}</style>

            <button
                className={`flex items-center text-xl p-2 mt-2 rounded-[10px] border-2 ${
                    isFavorite
                        ? 'text-white bg-rose-500'
                        : 'text-white bg-gray-800 border-gray-500'
                } ${isAnimating ? 'heartbeat' : ''}`}
                onClick={handleFavoriteClick}
                id={`thumbIcon-${idModel}`}
            >
                <FaThumbsUp style={{ fontSize: '1.5rem', marginRight: '8px' }} />
                <span className="text-sm font-semibold">
                    {count}
                </span>
            </button>

            {/* Modal de Login */}
            {showLoginModal && (
                <div className="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-end justify-center min-h-dvh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        {/* Overlay */}
                        <div
                            className="fixed inset-0 bg-gray-500 bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75 transition-opacity"
                            aria-hidden="true"
                            onClick={() => setShowLoginModal(false)}
                        ></div>

                        <span className="hidden sm:inline-block sm:align-middle sm:h-dvh" aria-hidden="true">&#8203;</span>

                        {/* Modal Panel */}
                        <div className={`inline-block align-bottom ${darkMode ? 'dark' : ''} rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full`}>
                            <div className="bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="mt-3 text-center">
                                    <h3
                                        className="text-lg leading-6 font-medium text-gray-900 dark:text-white"
                                        id="modal-title"
                                    >
                                        You must be logged in to the page to add favorites.
                                    </h3>
                                </div>
                            </div>
                            <div className="bg-gray-50 dark:bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2 justify-center">
                                <button
                                    type="button"
                                    className="w-full sm:w-auto px-4 py-2 bg-rose-500 text-white rounded-full hover:bg-rose-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 dark:focus:ring-offset-gray-800"
                                    onClick={handleLoginClick}
                                >
                                    Login
                                </button>
                                <button
                                    type="button"
                                    className="mt-3 sm:mt-0 w-full sm:w-auto px-4 py-2 bg-rose-500 text-white rounded-full hover:bg-rose-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 dark:focus:ring-offset-gray-800"
                                    onClick={() => setShowLoginModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FavoriteButton;
